module.exports = __webpack_public_path__ + "/images/ico-external-link.9fcc954.svg";